import styles from './BottomCard.module.scss';
import parse from 'html-react-parser';

export interface IBottomCard {
  number: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  buttonComponent: JSX.Element;
}
const BottomCard = ({ number, title, subtitle, description, buttonComponent, image }: IBottomCard) => {
  return (
    <>
      <div className={`${styles.bottom_card} d-fl fd-c ai-c jc-sb`}>
        <div className={styles.top_container}>
          <div className={styles.title_container}>
            <div className={`${styles.number_container} d-fl ai-c jc-c`}>
              <p>{number}</p>
            </div>
            <p className={styles.title}>{title}</p>
          </div>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        <div className={`d-fl ai-c jc-c fd-c ${styles.image_container}`}>
          <img src={image} alt="" />
          <p className={styles.description}>{parse(description)}</p>
          <div className={`${styles.button_container} d-fl ai-c jc-c`}>{buttonComponent}</div>
        </div>
      </div>
    </>
  );
};
export default BottomCard;
